import MyAvatar from '@/components/my-avatar';
import { TagTypes } from '@/components/my-avatar/type';
import { ChatCategory, type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { useChatContext, useMembersByChatId } from '@/contexts/chat/context';
import ChatInfo from './components/chat-info';
import classes from './index.module.scss';

export interface ChatHeaderProps {
  className?: ClassNames;
  chat: Chat;
}

export default function ChatHeader({ className, chat }: ChatHeaderProps) {
  const {
    chatGroup: {
      chatGroupState: {
        state: { groupMap },
      },
    },
  } = useChatContext();

  const normalMemberList = useMembersByChatId(chat.chat_id);

  const group = useMemo(() => groupMap[chat.chat_id], [groupMap, chat.chat_id]);

  const isGroup = useMemo(() => chat.category === ChatCategory.GROUP, [chat.category]);

  return (
    <div className={cls(classes.chatHeader, className)}>
      <MyAvatar
        className={classes.avatar}
        src={chat.avatar!}
        category={chat.category}
        tagType={TagTypes.DESTROY}
        expireDuration={chat.expire_duration}
        info={chat?.user}
      />
      <ChatInfo
        chat={chat}
        isGroup={isGroup}
        group={group}
        normalMemberList={normalMemberList}
      />
    </div>
  );
}
